import React from 'react';
import styled from 'styled-components';
import { StaticImage } from "gatsby-plugin-image"
import { Script } from "gatsby"
import colors from '../../../../helpers/colors';

const Wrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;

    @media (max-width: 1200px) {
        padding: 0 50px;
    }

    @media (max-width: 850px) {
        padding: 0 20px;
    }

    @media (max-width: 769px) {
        padding: 0 15px;
    }
`;

const Title = styled.h4`
    font-size: 30px;
    font-weight: 900;
    color: ${colors.mvDarkGrey};
    margin-bottom: 5px;
    line-height: 1.5;
    margin: 0 auto;
    text-align: center;

    @media (max-width: 500px) {
        font-size: 26px;
        margin-top: 50px;
    }
`;

const TileContainer = styled.div`
    margin: 0px auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    #bzOpeningsContainer {
        margin: 0 auto;
    }

    .bzOpeningsList {
        margin: 50px auto 90px auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;   
        width: 1200px;

        @media (max-width: 1250px) {
            width: 100%;
        }
        @media (max-width: 500px) {
            margin: 30px auto 0 auto;
        }
    }

    .bzOpening {
        width: 48%;
        height: 120px;
        box-shadow: 0px 12px 22px ${colors.greyBoxShadow};
        border-radius: 8px;
        margin-bottom: 30px;
        display: flex;
        position: relative;
        padding: 24px;
        margin-right: 15px;

        @media (max-width: 850px) {
            width: 100%;
            margin-right: 8px;
            margin-bottom: 15px;
        }
    
        @media (max-width: 769px) {
            width: 100%;
            margin-bottom: 15px;
        }

        @media (max-width: 500px) {
            height: 130px;
        }
    
        @media (max-width: 400px) {
            width: 100%;
            margin-bottom: 25px;
            height: 180px;
            justify-content: flex-start;
        }
        
        a {
            text-decoration: none;
        }

        h2 {
            font-size: 20px;
            font-weight: 900;
            color: ${colors.mvDarkGrey};
            margin-bottom: 5px;
            text-align: left;

            @media (min-width: 850px) and (max-width: 1100px) {
                font-size: 17px;
            }

            @media (max-width: 500px) {
                font-size: 17px;
            }
            @media (max-width: 400px) {
                width: 100%;
            }
        }

        .bzMeta {
            list-style-type: none;
            .bzType {
                display: none;
            }
            .bzLocation {
                color: ${colors.paragraphTextColor};
                text-align: left;
                font-size: 15px;
                font-weight: 500;
                margin-bottom: 5px;
            }
            .bzDepartment {
                text-align: left;
                font-size: 16px;
                color: ${colors.paragraphTextColor};
                font-weight: 300;
                
                @media (max-width: 500px) {
                    font-size: 16px;
                }
            }
            span {
                margin-left: 0;
            }
            
            .bzSalary {
                display: none;
            }
        }
    }

    .bzButtonApply {
        position: absolute;
        right: 15px;
        top: 40px;
        background: ${colors.mvVividBlue};
        text-transform: none;
        font-size: 15px;
        font-weight: bold;
        padding: 11px 23px;
        border-radius: 20px;
        color: ${colors.mvWhite};
        cursor: pointer;
        border: none;
        box-shadow: 3px 3px 10px ${colors.blueBoxShadow};

        @media (max-width: 500px) {
            top: 60px;
        }
        @media (max-width: 400px) {
            bottom: 30px;
            left: auto;
            right: auto;
            top: auto;
        }
        @media (max-width: 350px) {
            bottom: 20px;
        }
    }

`;

const Amazing = styled.h4`
    color: ${colors.mvDarkGrey};
    font-size: 40px;
    font-weight: 900;
    margin: 150px auto 6px auto;
    text-align: center;

    @media (max-width: 500px) {
        font-size: 30px;
        margin-top: 100px;
    }
`;

const AmazingText = styled.p`
    color: ${colors.paragraphTextColor};
    font-size: 15px;
    margin: 0 auto;
    font-weight: 700;
    text-align: center;
`;

const BadgeRow = styled.div`
    display: flex;
    flex-direction: row;
    margin: 50px auto 100px auto;
    justify-content: center;

    @media (max-width: 500px) {
        flex-wrap: wrap;
    }
`;

const Badge = styled.div`
    width: 160px;
    margin-right: 20px;

    @media (max-width: 500px) {
        margin-bottom: 30px;
    }
`;

const FeatureSection = () => {
      
    return (
        <Wrapper id="openPostions" >
            <Title>Current Job Openings</Title>

            <TileContainer>
                <div id='bzOpeningsContainer'></div><Script src='https://motivosity.breezy.hr/embed/js?inline=true&group_by=none' />
            </TileContainer>
            
            <Amazing>Be a part of something amazing!</Amazing>
            <AmazingText>Motivosity is driving amazing results for companies across the world.</AmazingText>
            <BadgeRow>
                <Badge>
                    <StaticImage src="../../../../resources/images/badges/2022-best-career-growth.png" alt="2022 Best Career Growth badge" quality="100" placeholder="none" />
                </Badge>
                <Badge>
                    <StaticImage src="../../../../resources/images/badges/2022-best-company-outlook.png" alt="2022 Best Company Outlook badge" quality="100" placeholder="none" />
                </Badge>
                <Badge>
                    <StaticImage src="../../../../resources/images/badges/2022-best-leadership.png" alt="2022 Best Company Leadership badge" quality="100" placeholder="none" />
                </Badge>
                <Badge>
                    <StaticImage src="../../../../resources/images/badges/2022-best-slc.png" alt="2022 Best Company Salt Lake City Badge" quality="100" placeholder="none" />
                </Badge>
            </BadgeRow>
        </Wrapper>
      )
};

export default FeatureSection;
